import { ListInfo, ListItem } from '../types/Post';

// "1 song", "2 songs", "1 album". Every place a list prints its size goes
// through this, so a one-item draft never reads "1 songs".
export function formatItemCount(count: number, kind: string): string {
  var noun = kind === 'songs' ? 'song' : 'album';
  return count + ' ' + noun + (count === 1 ? '' : 's');
}

export function buildListSubhead(list: ListInfo): string {
  var label = formatItemCount(list.itemCount, list.kind);
  if (list.orderStyle === 'ranking') return label + ', ranked';
  if (list.orderStyle === 'grid') return label + ', 3x3';
  return label; // playlist and unordered (legacy) just show count
}

// Sort items by position ascending. For all styles (including rankings
// in countdown display), position=0 renders first.
export function orderListItems(items: ListItem[]): ListItem[] {
  var sorted = [...items];
  sorted.sort(function (a, b) {
    return a.position - b.position;
  });
  return sorted;
}

export function getListItemRank(item: ListItem, total: number): number {
  return total - item.position;
}

// A note as its author typed it. The server stores a note as its item's
// caption, with mentions of real users wrapped ({@name}); where a note is
// shown as plain text (the feed carousel) or edited (the composer), the
// wrapping comes off again.
export function plainNote(note: string): string {
  return note.replace(/\{@([a-zA-Z0-9_]+)\}/g, '@$1').replace(/\{#([a-zA-Z0-9_]+)\}/g, '#$1');
}

// How a list's cover collage splits its items into rows: every row full
// width with square tiles, as even as possible, the fuller rows last so the
// first items (a ranked list's top picks) get the biggest tiles. Columns grow
// with the square root, so the collage stays roughly square at any size:
// 5 -> [2, 3], 7 -> [2, 2, 3], 11 -> [3, 4, 4], 16 -> [4, 4, 4, 4].
export function collageRows(count: number): number[] {
  if (count <= 0) return [];
  var columns = Math.ceil(Math.sqrt(count));
  var rows = Math.ceil(count / columns);
  var base = Math.floor(count / rows);
  var extra = count % rows;
  var sizes: number[] = [];
  for (var i = 0; i < rows; i++) {
    sizes.push(base + (i >= rows - extra ? 1 : 0));
  }
  return sizes;
}

// A 3x3's nine squares, each item at its position (0 to 8). A draft can
// leave squares empty (null here); an item with no usable square, or one
// past the ninth, takes the first free square or is left out.
export function gridSquares(items: ListItem[]): (ListItem | null)[] {
  var squares: (ListItem | null)[] = [null, null, null, null, null, null, null, null, null];
  var unplaced: ListItem[] = [];
  items.forEach(function (item) {
    var at = item.position;
    if (typeof at === 'number' && at >= 0 && at < 9 && squares[at] === null) squares[at] = item;
    else unplaced.push(item);
  });
  unplaced.forEach(function (item) {
    var free = squares.indexOf(null);
    if (free >= 0) squares[free] = item;
  });
  return squares;
}
